<template>
  <div class="fadeIn">
    <template>
      <div class="error">
        <h1>404</h1>
        <p>Page Not Found</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Error"
};
</script>

<style scoped lang="scss">
.error {
  text-align: center;

  h1 {
    font-size: 7rem;
    line-height: 1;
  }

  p {
    font-size: 1.75rem;
  }
}
</style>
